module.exports = __webpack_public_path__ + "static/media/DAI_USDT_Mdex.87a8be82.png";